module.exports = __webpack_public_path__ + "static/media/photo-12.71e3fe98.avif";